/* ==========================================================================
   Aura Baby — homepage interactions (no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- reveal --- */
  var io = null;

  function initReveal(root) {
    var targets = (root || document).querySelectorAll('[data-aura-reveal]:not(.aura-in)');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('aura-in');
      });
      return;
    }

    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('aura-in');
            io.unobserve(e.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
      );
    }

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  /* -------------------------------------------------- why-choose swap-in --- */
  function initSwap(root) {
    var grids = (root || document).querySelectorAll('[data-aura-swap]:not(.aura-swap)');
    if (!grids.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      grids.forEach(function (g) {
        g.classList.add('aura-swap');
      });
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('aura-swap');
          obs.unobserve(e.target);
        });
      },
      // Fires once the row is meaningfully on screen so the cross-over reads.
      { threshold: 0.35 }
    );

    grids.forEach(function (g) {
      obs.observe(g);
    });
  }

  /* ------------------------------------------------- testimonial carousel --- */
  function initCarousel(root) {
    (root || document).querySelectorAll('[data-aura-carousel]').forEach(function (car) {
      if (car.dataset.bound === 'true') return;
      car.dataset.bound = 'true';

      var track = car.querySelector('.aura-tcar__track');
      var slides = Array.prototype.slice.call(car.querySelectorAll('.aura-tcar__slide'));
      var prev = car.querySelector('[data-aura-prev]');
      var next = car.querySelector('[data-aura-next]');
      var dots = Array.prototype.slice.call(car.querySelectorAll('[data-aura-dot]'));
      if (!track || slides.length === 0) return;

      var index = 0;
      var count = slides.length;
      var autoplay = car.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(car.getAttribute('data-interval') || '6000', 10);
      var timer = null;

      function render() {
        track.style.transform = 'translate3d(' + -index * 100 + '%,0,0)';
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function go(i) {
        index = (i + count) % count; // wraps both directions
        render();
      }

      function start() {
        if (!autoplay || count < 2 || reduced) return;
        stop();
        timer = window.setInterval(function () {
          go(index + 1);
        }, interval);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      if (prev) {
        prev.addEventListener('click', function () {
          go(index - 1);
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          go(index + 1);
          start();
        });
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          go(i);
          start();
        });
      });

      car.addEventListener('mouseenter', stop);
      car.addEventListener('mouseleave', start);

      car.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          go(index - 1);
          start();
        }
        if (e.key === 'ArrowRight') {
          go(index + 1);
          start();
        }
      });

      // Touch swipe
      var startX = null;
      car.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX;
          stop();
        },
        { passive: true }
      );
      car.addEventListener(
        'touchend',
        function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
          startX = null;
          start();
        },
        { passive: true }
      );

      render();
      start();
    });
  }

  /* ---------------------------------------------------------------- header --- */
  function initHeader(root) {
    (root || document).querySelectorAll('[data-aura-header]').forEach(function (header) {
      if (header.dataset.bound === 'true') return;
      header.dataset.bound = 'true';

      function onScroll() {
        header.classList.toggle('is-stuck', window.scrollY > 8);
      }
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  }

  /* ----------------------------------------------------------- mobile menu --- */
  function initMenu(root) {
    (root || document).querySelectorAll('[data-aura-menu]').forEach(function (menu) {
      if (menu.dataset.bound === 'true') return;
      menu.dataset.bound = 'true';

      var id = menu.getAttribute('data-aura-menu');

      function open() {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      document.querySelectorAll('[data-aura-menu-open="' + id + '"]').forEach(function (b) {
        b.addEventListener('click', open);
      });
      menu.querySelectorAll('[data-aura-menu-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
      });
    });
  }

  /* ------------------------------------------------------------------ faq --- */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-aura-faq]').forEach(function (list) {
      if (list.dataset.bound === 'true') return;
      list.dataset.bound = 'true';

      var single = list.getAttribute('data-faq-single') === 'true';
      var items = Array.prototype.slice.call(list.querySelectorAll('.aura-faq__item'));

      items.forEach(function (item) {
        var btn = item.querySelector('.aura-faq__q');
        var panel = item.querySelector('.aura-faq__a');
        if (!btn || !panel) return;

        function setOpen(state) {
          item.classList.toggle('is-open', state);
          btn.setAttribute('aria-expanded', state ? 'true' : 'false');
          panel.style.height = state ? panel.scrollHeight + 'px' : '0px';
          if (state) {
            window.setTimeout(function () {
              if (item.classList.contains('is-open')) panel.style.height = 'auto';
            }, 420);
          }
        }

        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
          btn.setAttribute('aria-expanded', 'true');
        }

        btn.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          if (panel.style.height === 'auto') panel.style.height = panel.scrollHeight + 'px';
          void panel.offsetHeight;

          if (single && willOpen) {
            items.forEach(function (other) {
              if (other === item || !other.classList.contains('is-open')) return;
              var op = other.querySelector('.aura-faq__a');
              var ob = other.querySelector('.aura-faq__q');
              op.style.height = op.scrollHeight + 'px';
              void op.offsetHeight;
              other.classList.remove('is-open');
              ob.setAttribute('aria-expanded', 'false');
              op.style.height = '0px';
            });
          }
          setOpen(willOpen);
        });
      });
    });
  }

  /* -------------------------------------------------------------- marquee --- */
  function initMarquee(root) {
    (root || document).querySelectorAll('[data-aura-marquee]').forEach(function (track) {
      if (track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';

      var original = track.querySelector('.aura-marquee__item');
      if (!original) return;

      // The -100% keyframe shifts by exactly one item, so clone until the
      // track covers the viewport twice over and the loop reads seamlessly.
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 20) {
        track.appendChild(original.cloneNode(true));
        guard++;
      }
      track.appendChild(original.cloneNode(true));
    });
  }

  /* --------------------------------------------------------------- boot --- */
  function boot(root) {
    initReveal(root);
    initSwap(root);
    initCarousel(root);
    initHeader(root);
    initMenu(root);
    initFaq(root);
    initMarquee(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    boot(e.target);
  });

  window.AuraCustom = { boot: boot };
})();
